import { render, staticRenderFns } from "./ArchivedDealModal.vue?vue&type=template&id=f9f90f90&scoped=true"
import script from "./ArchivedDealModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchivedDealModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArchivedDealModal.vue?vue&type=style&index=0&id=f9f90f90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f90f90",
  null
  
)

export default component.exports